import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import { useDispatch } from 'react-redux';
import { setSalesData } from "../../redux/actions/leadSourceActions";
import Tooltip from '@material-ui/core/Tooltip';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    withStyles,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TableContainer
} from "@material-ui/core";
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME } from '../../utils/index';
import { useSelector } from 'react-redux';
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { Link } from 'react-router-dom'
import RefreshIcon from "@material-ui/icons/Refresh"; // Refresh Icon

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: '1px solid #eee5e5',
        background: "blue"
    },
    table: {
        minWidth: 700,
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        overflowX: "initial"
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        // "&:hover": { 
        //     backgroundColor: "#f7b7b7", // same light red on hover
        //     color: '#151921' // same text color on hover
        // }
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
          backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
      },
    clearButton: {
        backgroundColor: '#FFF2EB !important',   // Light Beige
        color: '#1C375D !important',             // Decorpot Orange text
        '&:hover': {
          backgroundColor: '#E7BAD0 !important', // Light Pink on hover
        },
    },
    searchButton: {
        backgroundColor: '#FDB913 !important',  // Bright Yellow for emphasis
        color: '#1C375D !important',            // Dark Blue text for contrast
        '&:hover': {
          backgroundColor: '#E6A411 !importan', // Darker yellow on hover
        },
      },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500"
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const SalesSummary = (props) => {
    const classes = useStyles();
    const salesData = useSelector((state) => state.leadSource.salesData);
    const dispatch = useDispatch();
    const { userDetails } = useSelector((state) => state.user);
    const [store, setStore] = useState([]);
    const [commonExpCenter, setExpCenter] = useState([])
    const [commonLocation, setLocation] = useState([])
    const [pivot, setPivot] = useState("value")
    const [storeDateFilter, setPivotDatefilters] = useState({ startDate: "", endDate: "" })
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const [selectedLocation, setSelectedLocation] = useState([])
    const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', "Oct", "Nov", "Dec"];
    const [selectedValue, setSelectedValue] = useState("");
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [popMonthData, setPopMonthData] = useState([]);
    const [selectedRole, setSelectedRole] = useState('');
    const [usersData, setUsersData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [status, setStaus] = useState('');
    const [selectLost, setSeletLost] = useState('')
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']


    const [isGroupCreationMode, setIsGroupCreationMode] = useState(false); // Toggle mode
    const [isGroupCreationModeForCustomer, setIsGroupCreationModeForCustomer] = useState(false); // Toggle mode for customer
    const [selectedHeadingForMain, setSelectedHeadingForMain] = useState([]); // State for main headings
    const [selectedRowsForMain, setSelectedRowsForMain] = useState([]); // State for main rows
    const [selectedHeadingForCustomer, setSelectedHeadingForCustomer] = useState([]); // State for customer headings
    const [selectedRowsForCustomer, setSelectedRowsForCustomer] = useState([]); // State for customer rows
    const [formCategoryName, setFormCategoryName] = useState(''); // State for form category name
    const [isDialogOpen, setIsDialogOpen] = useState(false); // Flag to manage dialog visibility
    const [showMainTable, setMainTable] = useState(false)
    const [showCustomerMainTable, setShowCustomerTable] = useState(false)
    const [storeMainTableData, setStoreMainTableData] = useState([])
    const [storeMainTableDataForCustomer, setStoreMainTableDataForCustomer] = useState([])
    const [storeGroupDetails, setStoreGroupDetails] = useState([])
    const [storeGroupDetailsCustomer, setStoreGroupDetailsCustomer] = useState([])
    const [storeUserGroupDetails, setUserGroupDetails] = useState([])
    const [storeUserGroupDetailsForCustomer, setUserGroupDetailsForCustomer] = useState([])
    const [selectedGroup, setSelectedGroup] = useState('');
    const [selectedGroupForCustomer, setSelectedGroupForCustomer] = useState('')
    const [isLoading, setIsLoading] = useState(false);
    const [groupName, setGroupName] = useState('');
    const [isGroupingMode, setIsGroupingMode] = useState(false);
    const [selectedHeadings, setSelectedHeadings] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);
    const [lastUsedParams, setLastUsedParams] = useState(null);
    const [isInitialRender, setIsInitialRender] = useState(true);
    const SECOND_BUTTON_DISABLE_UNTIL_KEY = 'secondButton_disableUntil';


    useEffect(() => {
        expCenters();
        locations();
        dynamicGroupDetails()
        fetchUsersData();
        if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            callFunction()
            setSelectedRole(ROLENAME.SalesUser)
        } else {
            callFunction()
            setSelectedRole("ALL")
        }
    }, []);

    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "createdAt", label: "CreatedAt" },
        { key: "sourceOfLead", label: "Source Of Lead" },
        { key: "salesUser", label: "Sales Executive" },
        { key: "salesAssistantManager", label: "Sales Assistant Manager" },
        { key: "salesManager", label: "Sales Manager" },
        { key: "salesDGM", label: "Sales DGM" },
        { key: "salesAGM", label: "Sales AGM" },
        { key: "totalValue", label: "Value (INR)" },
        { key: "location", label: "City" },
        { key: "expCtrName", label: "Exp. Ctr Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "designKickOffInternalApprovalDate", label: "Design KOM Internal Date" },
        { key: "designSignOffDate", label: "Design Sign-Off Date" },
        { key: "materialDeliveryDate", label: "Material Delivery Date" },
        { key: "actualCompletionDate", label: "Actual Completion Date" },
        { key: "tokenPercent", label: "Token % Received" },
    ];

    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < popMonthData.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    projectCode: popMonthData[i]?.erpProjectNo || "N/A",
                    leadNumber: popMonthData[i]?.lead_no || "N/A",
                    clientName: popMonthData[i]?.customerId?.name,
                    totalValue:
                        (popMonthData[i]?.staticSalesWonBudget),
                    location: popMonthData[i]?.salesWonExpCtrId?.locationId?.name,
                    expCtrName: popMonthData[i]?.salesWonExpCtrId?.name,
                    createdAt: popMonthData[i]?.createdAt
                        ? moment(popMonthData[i]?.createdAt).format("DD-MM-YYYY")
                        : "-",
                    sourceOfLead: popMonthData[i]?.sourceOfLead?.name,
                    salesWonDate: popMonthData[i]?.leadWonDate
                        ? moment(popMonthData[i]?.leadWonDate).format("DD-MM-YYYY")
                        : "-",
                    
                    designKickOffInternalApprovalDate: popMonthData[i]?.designKickOffInternalApprovalDate
                        ? moment(popMonthData[i]?.designKickOffInternalApprovalDate).format("DD-MM-YYYY")
                        : "-",
                    salesUser: popMonthData[i]?.salesUser ? popMonthData[i]?.salesUser?.name : 'NA',
                    salesManager: popMonthData[i]?.salesManager ? popMonthData[i]?.salesManager?.name : 'NA',
                    salesDGM: popMonthData[i]?.salesDGM ? popMonthData[i]?.salesDGM?.name : 'NA',
                    salesAGM: popMonthData[i]?.salesAGM ? popMonthData[i]?.salesAGM?.name : 'NA',
                    salesAssistantManager: popMonthData[i]?.salesAssistantManager ? popMonthData[i]?.salesAssistantManager?.name : 'NA',
                    designUser: popMonthData[i]?.designUser ? popMonthData[i]?.designUser?.name : 'NA',
                    designManager: popMonthData[i]?.designManager ? popMonthData[i]?.designManager?.name : 'NA',
                    designDGM: popMonthData[i]?.designDGM ? popMonthData[i]?.designDGM?.name : 'NA',
                    designAssistantManager: popMonthData[i]?.designAssistantManager ? popMonthData[i]?.designAssistantManager?.name : 'NA',
                    currentStage: popMonthData[i]?.currentStage ? popMonthData[i]?.currentStage : 'NA',
                    designStage: popMonthData[i]?.designStage ? popMonthData[i]?.designStage : "NA",
                    designSignOffDate: popMonthData[i]?.customerDesignSignOffDate
                        ? moment(popMonthData[i]?.customerDesignSignOffDate).format("DD-MM-YYYY")
                        : "-",
                    materialDeliveryDate: popMonthData[i]?.materialDispatchedDate
                        ? moment(popMonthData[i]?.materialDispatchedDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    actualCompletionDate: popMonthData[i]?.executionCompletionDate
                        ? moment(popMonthData[i]?.executionCompletionDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    tokenPercent: popMonthData[i]?.tokenPercent !== null ? popMonthData[i]?.tokenPercent : "null",
                };
                csvArray.push(obj);
                // obj = {
                //     serialNo: "",
                //     projectCode: "",
                //     clientName: "",
                //     totalValue: "",
                //     expCtrName: "",
                //     salesWonDate: "",
                //     designSignOffDate: "",
                //     materialDeliveryDate: "",
                //     actualCompletionDate: "",
                // };
                // csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };
    const expCenterData = {};
    store.forEach((el) => {
        if (!expCenterData[el.experienceCenterName]) {
            expCenterData[el.experienceCenterName] = [];
        }
        expCenterData[el.experienceCenterName].push(el);
    });
    const uniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));
    let uniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));


    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const locations = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getLocation();
            const matchedUsers = response.data.filter(user => {
                return userDetails.selectedLocation.includes(user._id);
            });
            setLocation(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

 
// Add this effect to initialize state from localStorage and handle timer
useEffect(() => {
    // Check if there's a stored disable time in localStorage
    const disableUntilTimestamp = localStorage.getItem(SECOND_BUTTON_DISABLE_UNTIL_KEY);
    
    if (disableUntilTimestamp) {
      const now = new Date().getTime();
      const disableUntil = parseInt(disableUntilTimestamp, 10);
      
      // If the disable time is in the future, calculate remaining time
      if (disableUntil > now) {
        const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
        setTimeLeft(remainingTimeInSeconds);
        setIsDisabled(true);
      } else {
        // If the time has passed, clear localStorage
        localStorage.removeItem(SECOND_BUTTON_DISABLE_UNTIL_KEY);
        setIsDisabled(false);
        setTimeLeft(0);
      }
    }
    
    // Set up timer to update remaining time
    let timer;
    if (isDisabled && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft(prevTime => {
          const newTime = prevTime - 1;
          if (newTime <= 0) {
            // When time is up, clear localStorage and enable button
            localStorage.removeItem(SECOND_BUTTON_DISABLE_UNTIL_KEY);
            setIsDisabled(false);
            return 0;
          }
          return newTime;
        });
      }, 1000);
    }
    
    return () => clearInterval(timer);
  }, [isDisabled, timeLeft]);
  
  // Format time for display
  const formatTimeLeft = () => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };
  
  // Replace your existing handleRefreshClick with this
  const handleRefreshClick = () => {
    // Calculate the timestamp 4 minutes from now
    const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);
    
    // Store the timestamp in localStorage
    localStorage.setItem(SECOND_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());
    
    // Disable the button for 4 minutes
    setIsDisabled(true);
    setTimeLeft(240); // 4 minutes in seconds
    
    // Run the original functionality
    setIsSpinning(true);
    clearDateFilter();
    setTimeout(() => {
      setIsSpinning(false);
    }, 1000);
  };
  
  
  
      const isEqual = (obj1, obj2) => {
          // First check if both objects have the same keys
          const keys1 = Object.keys(obj1);
          const keys2 = Object.keys(obj2);
          
          if (keys1.length !== keys2.length) {
              return false;
          }
          
          // Check if all keys in obj2 exist in obj1
          for (const key of keys2) {
              if (!keys1.includes(key)) {
                  return false;
              }
          }
          
          // Then compare each key's value
          for (const key in obj1) {
              if (Array.isArray(obj1[key])) {
                  // For arrays, check if they have the same length and same items
                  if (!Array.isArray(obj2[key]) || obj1[key].length !== obj2[key].length) {
                      return false;
                  }
                  
                  // For arrays of objects with _id, compare by _id
                  if (obj1[key].length > 0 && obj1[key][0]?._id) {
                      const obj1Ids = new Set(obj1[key].map(item => item._id));
                      const obj2Ids = new Set(obj2[key].map(item => item._id));
                      
                      // Check if sets are equal
                      if (obj1Ids.size !== obj2Ids.size) {
                          return false;
                      }
                      
                      for (const id of obj1Ids) {
                          if (!obj2Ids.has(id)) {
                              return false;
                          }
                      }
                  } else {
                      // Simple comparison for primitive arrays
                      for (let i = 0; i < obj1[key].length; i++) {
                          if (obj1[key][i] !== obj2[key][i]) {
                              return false;
                          }
                      }
                  }
              } else if (obj1[key] !== obj2[key]) {
                  return false;
              }
          }
          
          return true;
      };
  
      const callFunction = async (addLocation, addExpCenter, usersData, selectedSearchType, searchInput) => {
          // Build your object as before
          let locationData = addLocation?.map((el) => el._id)
          let expCenterData = addExpCenter?.map((el) => el._id)
          let users = '';
          if ((usersData?.users && usersData?.users.length !== 0) || (selectedUsers && selectedUsers.length !== 0)) {
              users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id)
          }
          
          let currentObj = {
              startDate: storeDateFilter.startDate,
              endDate: storeDateFilter.endDate,
              selectedLocation: locationData ? locationData : "",
              selectedExperienceCenter: expCenterData ? expCenterData : "",
              tokenPercentage: selectedValue !== "" ? selectedValue : "",
              users: users ? users : "",
              userExpCenter: userDetails.experienceCenterId,
              userLocation: userDetails.selectedLocation,
              lost: selectLost !== "" ? selectLost : "",
              pivotValue: 'value',
              searchType: selectedSearchType ? selectedSearchType : "",
              search: searchInput ? searchInput.toUpperCase() : ""
          }
          
          if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
              currentObj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.SalesUser;
          } else {
              currentObj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL");
          }
          
          // Determine if we need to make API call
          let shouldMakeApiCall = false;
          
          // Case 1: No salesData - must call API
          if (!salesData ||  salesData === null) {
              shouldMakeApiCall = true;
          } 
          // Case 2: Not initial render AND parameters changed
          else if (!isInitialRender && lastUsedParams && !isEqual(lastUsedParams, currentObj)) {
              shouldMakeApiCall = true;
          }
          
          props.setLoading(true);
          
          try {
              if (shouldMakeApiCall) {
                  // Call API with current parameters
                  let response = await HttpService.getSalesDataBasedOnExpCenter(currentObj);
                  setStore(response.data);
                  dispatch(setSalesData(response.data));
              } else {
                  // Use existing data
                  setStore(salesData);
              }
              
              // Always save the current parameters
              setLastUsedParams({...currentObj});
              
              // No longer initial render after first execution
              if (isInitialRender) {
                  setIsInitialRender(false);
              }
          } catch (error) {
              props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
          }
          
          props.setLoading(false);
      };
    

    // const checkPivot = async (value) => {
    //     setPivot(value)
    //     if (value === 'value' || value === 'total') {
    //         callFunction()
    //         setSelectedExperienceCenter([])
    //         setSelectedUsers([])
    //         setSelectedRole("ALL")
    //         handleSelectRoles(null, ROLENAME.SalesUser)
    //     }
    // }

    const formatNumberToTwoDecimalPlaces = (value) => {
        return parseFloat(value).toFixed(2);
    }

    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDatefilters({ ...storeDateFilter, [name]: value })
    }
    const handlePivotDateFilter = () => {
        if (showMainTable) {
            callFunctionForGroup(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
        }
        if (showCustomerMainTable) {
            callFunctionForCustomer(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
        }
        else {
            callFunction(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
        }
    }
    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }
    const handleSearch = async (value) => {
        if (showMainTable) {
            callFunctionForGroup(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
        }
        if (showCustomerMainTable) {
            callFunctionForCustomer(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
        }
        else {
            callFunction(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
        }

    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && selectedSearchType && searchInput) {
            handleSearch(searchInput.toUpperCase());
        }
    };

    const handleSelectChange = async (event) => {
        setSelectedValue(event.target.value);
        let locationData = selectedLocation?.map((el) => el._id)
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userLocation: userDetails.selectedLocation,
            userExpCenter: userDetails.selectedExpCenter,
            tokenPercentage: event.target.value !== "" ? event.target.value : "",
            lost: selectLost !== "" ? selectLost : "",
            groupId: selectedGroup ? selectedGroup : ""
        }
        props.setLoading(true);
        try {
            let users = ''
            if (selectedUsers && selectedUsers.length !== 0) {
                users = selectedUsers?.map((el) => el._id)
            }
            obj.users = users ? users : ""
            obj.selectedRole = selectedRole
            obj.pivotValue = pivot

            let response;
            if (showMainTable) {
                response = await HttpService.getSalesDataBasedOnExpCenterForSalesGroup(obj);
            }
            if (showCustomerMainTable) {
                response = await HttpService.getSalesDataBasedOnExpCenterForSalesGroup(obj);
            }
            if(!showMainTable && !showCustomerMainTable){
                response = await HttpService.getSalesDataBasedOnExpCenter(obj);
            }

            if (showMainTable) {
                setStoreMainTableData(response.data)
            }
            if (showCustomerMainTable) {
                setStoreMainTableDataForCustomer(response.data)
            }
            if(!showMainTable && !showCustomerMainTable){
                setStore(response.data);
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const handleSelctLost = async (event) => {
        setSeletLost(event.target.value)
        let locationData = selectedLocation?.map((el) => el._id)
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userLocation: userDetails.selectedLocation,
            tokenPercentage: selectedValue !== "" ? selectedValue : "",
            lost: event.target.value !== "" ? event.target.value : '',
            groupId: selectedGroup ? selectedGroup : ""
        }
        props.setLoading(true);
        try {
            let users = ''
            if (selectedUsers && selectedUsers.length !== 0) {
                users = selectedUsers?.map((el) => el._id)
            }
            obj.users = users ? users : ""
            obj.selectedRole = selectedRole
            obj.pivotValue = 'value'
            obj.userExpCenter = userDetails.selectedExpCenter
            let response;
            if (showMainTable) {
                response = await HttpService.getSalesDataBasedOnExpCenterForSalesGroup(obj);
            }
            if (showCustomerMainTable) {
                response = await HttpService.getSalesDataBasedOnExpCenterForSalesGroup(obj);
            }
            if(!showMainTable && !showCustomerMainTable){
                response = await HttpService.getSalesDataBasedOnExpCenter(obj);
            }

            if (showMainTable) {
                setStoreMainTableData(response.data)
            }
            if (showCustomerMainTable) {
                setStoreMainTableDataForCustomer(response.data)
            }
            if(!showMainTable && !showCustomerMainTable){
                setStore(response.data);
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const handleSelectRoles = async (event, role) => {
        setSelectedUsers([])
        let obj = {}
        if (role) {
            obj.role = role
        } else {
            setSelectedRole(event.target.value)
            obj.role = event.target.value
        }
        obj.pivotValue = pivot
        try {
            let response
            if (showMainTable) {
                let response = await HttpService.getSelectedUsersBasedOnRoles(obj);

                if (!role) {
                    await callFunctionForGroup(selectedLocation, selectedExperienceCenter, obj, selectedSearchType, searchInput)
                }
                setUsersData(response.data);
            }
            if (showCustomerMainTable) {
                let response = await HttpService.getSelectedUsersBasedOnRoles(obj);

                if (!role) {
                    await callFunctionForCustomer(selectedLocation, selectedExperienceCenter, obj, selectedSearchType, searchInput)
                }
                setUsersData(response.data);
            }
            else {
                let response = await HttpService.getSelectedUsersBasedOnRoles(obj);
                if (!role) {
                    await callFunction(selectedLocation, selectedExperienceCenter, obj, selectedSearchType, searchInput)
                }
                setUsersData(response.data);
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
    }

    const fetchUsersData = async () => {
        let obj = {}
        if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            obj.role = ROLENAME.SalesUser
        } else if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            obj.role = ROLENAME.DesignUser
        } else {
            obj.role = "ALL"
        }
        try {
            let response = await HttpService.getSelectedUsersBasedOnRoles(obj);
            setUsersData(response.data)
        } catch (error) {
            console.log(error,"error")
        }
    }

    const handleMultipleExpData = (e, newvalue) => {
        setSelectedExperienceCenter(newvalue)
        handleExpData(newvalue)
    }
    const handleExpData = async (newvalue) => {
        props.setLoading(true);
        if (showMainTable) {
            await callFunctionForGroup(selectedLocation, newvalue, selectedUsers, selectedSearchType, searchInput)

        }
        if (showCustomerMainTable) {
            await callFunctionForCustomer(selectedLocation, newvalue, selectedUsers, selectedSearchType, searchInput)
        }
        else {
            await callFunction(selectedLocation, newvalue, selectedUsers, selectedSearchType, searchInput)

        }
        props.setLoading(false);
    }

    const handleMultipleLocationData = (e, newValue) => {
        setSelectedLocation(newValue)
        handleLocationData(newValue)
    }
    const handleLocationData = async (newValue) => {
        props.setLoading(true);

        if (showMainTable) {
            await callFunctionForGroup(newValue, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)

        }
        if (showCustomerMainTable) {
            await callFunctionForCustomer(newValue, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)

        }
        if (!showMainTable || !showCustomerMainTable) {
            await callFunction(newValue, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
        }
        props.setLoading(false);
    }
    const handleMultipleUsers = (e, newvalue) => {
        setSelectedUsers(newvalue)
        handleUsersData(newvalue)
    }

    const handleUsersData = async (newvalue) => {
        props.setLoading(true);
        let obj = {
            users: newvalue,
            role: selectedRole
        }
        if (showMainTable) {
            await callFunctionForGroup(selectedLocation, selectedExperienceCenter, obj, selectedSearchType, searchInput)
        }
        if (showCustomerMainTable) {
            await callFunctionForCustomer(selectedLocation, selectedExperienceCenter, obj, selectedSearchType, searchInput)
        }
        else {
            await callFunction(selectedLocation, selectedExperienceCenter, obj, selectedSearchType, searchInput)
        }
        props.setLoading(false);
    }

    const getDataBasedOnClickSales = async (e, month, innerEl, val) => {
        let obj = {}
        let users = ''
        let expCenterData =
            selectedExperienceCenter && selectedExperienceCenter.length > 0
                ? selectedExperienceCenter.map((el) => el._id)
                : "";
        let locationData =
            selectedLocation && selectedLocation.length > 0
                ? selectedLocation.map((el) => el._id)
                : "";
        if (selectedUsers && selectedUsers.length !== 0) {
            users = selectedUsers?.map((el) => el._id)
        }
        if (val === 'value') {
            obj = {
                _id: { month: month.monthNumber, year: month.year },
                dateInfo :storeDateFilter,
                selectedExperienceCenter: innerEl.experienceCenterId ? innerEl.experienceCenterId : expCenterData,
                selectedLocation: innerEl.locationId ? innerEl.locationId : locationData,
                tokenPercentage: selectedValue !== "" ? selectedValue : "",
                lost: selectLost !== "" ? selectLost : "",
                pivotValue: 'value',
                selectedRole: selectedRole ? selectedRole : "",
                userExpCenter: userDetails.experienceCenterId,
                userLocation: userDetails.selectedLocation,
                users: users ? users : "",
                searchType: selectedSearchType ? selectedSearchType : "",
                search: searchInput !== "" ? searchInput.toUpperCase() : ""
            }
        } else if (val === 'total') {
            if (innerEl === "Grand Total") {
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endMonth: month[month.length - 1].monthNumber, endYear: month[month.length - 1].year },
                    dateInfo :storeDateFilter,
                    selectedExperienceCenter: expCenterData,
                    selectedLocation: locationData,
                    tokenPercentage: selectedValue !== "" ? selectedValue : "",
                    lost: selectLost !== "" ? selectLost : "",
                    pivotValue: 'value',
                    selectedRole: selectedRole ? selectedRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    users: users ? users : "",
                    searchType: selectedSearchType ? selectedSearchType : "",
                    search: searchInput !== "" ? searchInput.toUpperCase() : ""
                }
            } else {
                let expCenter;
                for (let i = 0; i < store.length; i++) {
                    if (store[i].experienceCenterName === innerEl) {
                        expCenter = store[i].experienceCenterId
                        break;
                    }
                }
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endMonth: month[month.length - 1].monthNumber, endYear: month[month.length - 1].year },
                    dateInfo :storeDateFilter,
                    selectedExperienceCenter: expCenter,
                    selectedLocation: locationData,
                    tokenPercentage: selectedValue !== "" ? selectedValue : "",
                    lost: selectLost !== "" ? selectLost : "",
                    pivotValue: 'value',
                    selectedRole: selectedRole ? selectedRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    users: users ? users : "",
                    searchType: selectedSearchType ? selectedSearchType : "",
                    search: searchInput !== "" ? searchInput.toUpperCase() : ""
                }
            }
        }
        props.setLoading(true);
        try {
            let response = await HttpService.getDataBasedClickSales(obj);
            setPopMonthData(response.data)
            setShowDetailedModal(true)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }


    const getDataBasedOnClickSalesForGroup = async (e, month, innerEl, val) => {

        let obj = {}
        let users = ''
        let expCenterData =
            selectedExperienceCenter && selectedExperienceCenter.length > 0
                ? selectedExperienceCenter.map((el) => el._id)
                : "";
        let locationData =
            selectedLocation && selectedLocation.length > 0
                ? selectedLocation.map((el) => el._id)
                : "";
        if (selectedUsers && selectedUsers.length !== 0) {
            users = selectedUsers?.map((el) => el._id)
        }
        if (val === 'value') {
            // Extract individual months if `monthName` contains '/'
            const combinedMonths = month.monthName.includes('/')
                ? month.monthName.split('/').map((name) => ({
                    monthName: name.trim(), // Trim to handle any extra spaces
                    year: month.year // Keep the same year
                }))
                : [{ monthName: month.monthName, year: month.year }]; // Single month case

            // Create the main object
            obj = {
                _id: { month: month.monthNumber, year: month.year },
                selectedExperienceCenter:
                    Array.isArray(innerEl.experienceCenterId) && innerEl.experienceCenterId[0] === null
                        ? expCenterData
                        : innerEl.experienceCenterId || "",
                selectedLocation: innerEl.locationId ? innerEl.locationId : locationData,
                tokenPercentage: selectedValue !== "" ? selectedValue : "",
                lost: selectLost !== "" ? selectLost : "",
                pivotValue: 'value',
                selectedRole: selectedRole ? selectedRole : "",
                userExpCenter: userDetails.experienceCenterId,
                userLocation: userDetails.selectedLocation,
                users: users ? users : "",
                searchType: selectedSearchType ? selectedSearchType : "",
                search: searchInput !== "" ? searchInput.toUpperCase() : "",
                combinedMonths // Add the array of extracted months
            };
        }
        else if (val === 'total') {

            if (innerEl === "Grand Total") {
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endMonth: month[month.length - 1].monthNumber, endYear: month[month.length - 1].year },
                    selectedExperienceCenter:
                        Array.isArray(innerEl.experienceCenterId) && innerEl.experienceCenterId[0] === null
                            ? ""
                            : innerEl.experienceCenterId || "",
                    selectedLocation: locationData,
                    tokenPercentage: selectedValue !== "" ? selectedValue : "",
                    lost: selectLost !== "" ? selectLost : "",
                    pivotValue: 'value',
                    selectedRole: selectedRole ? selectedRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    users: users ? users : "",
                    searchType: selectedSearchType ? selectedSearchType : "",
                    search: searchInput !== "" ? searchInput.toUpperCase() : ""
                }
            } else {

                let expCenter;
                for (let i = 0; i < store.length; i++) {
                    if (store[i].experienceCenterName === innerEl) {
                        expCenter = store[i].experienceCenterId
                        break;
                    }
                }
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endMonth: month[month.length - 1].monthNumber, endYear: month[month.length - 1].year },
                    selectedExperienceCenter:
                        Array.isArray(innerEl.experienceCenterId) && innerEl.experienceCenterId[0] === null
                            ? ""
                            : innerEl.experienceCenterId || "",
                    selectedLocation: locationData,
                    tokenPercentage: selectedValue !== "" ? selectedValue : "",
                    lost: selectLost !== "" ? selectLost : "",
                    pivotValue: 'value',
                    selectedRole: selectedRole ? selectedRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    users: users ? users : "",
                    searchType: selectedSearchType ? selectedSearchType : "",
                    search: searchInput !== "" ? searchInput.toUpperCase() : ""
                }
            }
        }
        props.setLoading(true);
        try {
            const response = await HttpService.getDataBasedClickSales(obj);
            setPopMonthData(response.data);
            setShowDetailedModal(true);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
        }
        props.setLoading(false);
    };

    const clearDateFilter = () => {
        setSearchInput("")
        setSelectedSearchType("")
        setMainTable(false);
        setShowCustomerTable(false)
        setUserGroupDetailsForCustomer([])
        setUserGroupDetails([]);
        setStoreMainTableData([])
        callFunction(selectedLocation, selectedExperienceCenter, selectedUsers, "", "")
    }
    const defaultCustomerTable = () => {
        setSearchInput("")
        setSelectedSearchType("")
        setShowCustomerTable(false)
        setUserGroupDetailsForCustomer([])
        setStoreMainTableDataForCustomer([])
        callFunction(selectedLocation, selectedExperienceCenter, selectedUsers, "", "")
    }

    const defaultSalesTable = () => {
        setSearchInput("")
        setSelectedSearchType("")
        setMainTable(false);
        setUserGroupDetails([]);
        setStoreMainTableData([])
        callFunction(selectedLocation, selectedExperienceCenter, selectedUsers, "", "")
    }

    const handleHeadingCheckboxChange = (code, isCustomer = false) => {
        const setHeadingState = isCustomer ? setSelectedHeadingForCustomer : setSelectedHeadingForMain;

        setHeadingState((prev) => {
            const updatedSelection = prev.includes(code)
                ? prev.filter((item) => item !== code)
                : [...prev, code];

            // Merge with the global selectedHeadings state
            setSelectedHeadings((globalPrev) => {
                return updatedSelection.reduce(
                    (acc, heading) => (acc.includes(heading) ? acc : [...acc, heading]),
                    globalPrev
                );
            });

            return updatedSelection;
        });
    };


    // Updated function for handling row checkbox changes
    const handleRowCheckboxChange = (monthName, isCustomer = false) => {
        const setRowState = isCustomer ? setSelectedRowsForCustomer : setSelectedRowsForMain;
    
        setRowState((prev) => {
            const updatedSelection = prev.includes(monthName)
                ? prev.filter((item) => item !== monthName)
                : [...prev, monthName];
    
            // Merge with the global selectedRows state
            setSelectedRows((globalPrev) => {
                return updatedSelection.reduce(
                    (acc, row) => (acc.includes(row) ? acc : [...acc, row]),
                    globalPrev
                );
            });
    
            return updatedSelection;
        });
    };
    

    const toggleGroupCreation = () => {
        if (isGroupCreationMode) {
            setIsDialogOpen(true); // Open the dialog to get form category name
        } else {
            const groupData = {
                selectedHeadings: [...new Set(selectedHeadings)], // Remove duplicates
                selectedRows: [...new Set(selectedRows)], // Remove duplicates
                formCategoryName: formCategoryName,
            };


            // API call to save groupData
        }
        setIsGroupCreationMode(!isGroupCreationMode);
    };

    const toggleGroupCreationForCancel = () =>{
        setIsGroupCreationMode(!isGroupCreationMode)
        setSelectedHeadingForMain([])
        setSelectedRowsForMain([])
    }

    const toggleGroupCreationForCancelForCuatomer = () =>{
        setIsGroupCreationModeForCustomer(!isGroupCreationModeForCustomer);
        setSelectedHeadingForMain([])
        setSelectedRowsForMain([])
    }
    const [adjustModel, setAdjustModel] = useState(false)

    const toggleGroupCreationForCustomer = () => {
        setAdjustModel(true)
        if (isGroupCreationModeForCustomer) {
            setIsDialogOpen(true); // Open the dialog to get form category name
        } else {
            const groupData = {
                selectedHeadings: [...new Set(selectedHeadings)], // Remove duplicates
                selectedRows: [...new Set(selectedRows)], // Remove duplicates
                formCategoryName: formCategoryName,
            };


            // API call to save groupData
        }
        setIsGroupCreationModeForCustomer(!isGroupCreationModeForCustomer);
    };

    // Add this close handler function with your other handlers
    const handleClose = () => {
        setIsDialogOpen(false);
        setIsGroupCreationMode(false);
        // Optionally reset other states when closing
        resetStates();
    };

    // Separate reset states function that can be reused
    const resetStates = () => {
        setGroupName('');
        setSelectedHeadingForMain([]);
        setSelectedRowsForMain([]);
        setSelectedHeadingForCustomer([]);
        setSelectedRowsForCustomer([]);
        setFormCategoryName('');
        setIsGroupingMode(false);
        setIsDialogOpen(false);
        setIsLoading(false);
    };


    const handleDialogSubmit = async () => {
        // Form validation
        if (!formCategoryName.trim()) {
            props.setSnackInfo("Please enter a category name", "error");
            return;
        }
    
        // Initialize previous headings and rows if undefined
        const previousHeadings = storeUserGroupDetails?.selectedHeadings || [];
        const previousRows = storeUserGroupDetails?.selectedRows || [];
    
        // Combine previous selected headings with the newly selected ones
        let selectedHeadingsCombined = [
            ...previousHeadings,
            selectedHeadingForMain.join('/')
        ].filter(Boolean);
    
        // Remove shorter headings that are included in longer ones
        selectedHeadingsCombined = selectedHeadingsCombined.filter(
            (heading, index, array) =>
                !array.some(
                    (otherHeading) =>
                        otherHeading !== heading &&
                        otherHeading.includes(heading)
                )
        );
    
        // Combine previous selected rows with the newly selected ones
        let selectedRowsCombined = [
            ...previousRows,
            selectedRowsForMain.join('/')
        ].filter(Boolean);
    
        // Remove shorter rows that are included in longer ones
        selectedRowsCombined = selectedRowsCombined.filter(
            (row, index, array) =>
                !array.some(
                    (otherRow) =>
                        otherRow !== row &&
                        otherRow.includes(row)
                )
        );
    
        // Fixed row merging logic to properly handle years
        selectedRowsCombined = selectedRowsCombined.map(row => {
            // Split the row into individual dates
            const dates = row.split('/');
        
            // Process each date to ensure consistent format
            const processedDates = dates.map(date => {
                if (date.trim()) { // Only process non-empty dates
                    // Extract the year and month from the date string
                    const match = date.match(/([a-zA-Z]+)?(\d{4})?/);
                    const monthPart = match && match[1] ? match[1].trim() : null;
                    const yearPart = match && match[2] ? match[2].trim() : null;
        
                    // Return the concatenated month and year if both exist
                    if (monthPart && yearPart) {
                        return monthPart + yearPart;
                    } else if (monthPart) {
                        // If only the month exists
                        return monthPart;
                    } else if (yearPart) {
                        // If only the year exists
                        return yearPart;
                    }
                }
                return null; // Return null for invalid or empty entries
            }).filter(Boolean); // Remove any null or undefined values
        
            // Join the processed dates back together
            return processedDates.join('/');
        });
        
        
        // Create the payload
        const selectedData = {
            groups: [
                {
                    groupName: formCategoryName,
                    selectedHeadings: selectedHeadingsCombined,
                    selectedRows: selectedRowsCombined,
                    formCategoryName: "Sales group"
                },
            ],
        };
    
        try {
            setIsLoading(true);
            const response = await HttpService.dynamicGroupingUserWise(selectedData);
            props.setSnackInfo(response.data.message, "success");
            resetStates();
            handleClose();
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.error || "Group Limit Exhausted";
            props.setSnackInfo(errorMessage, "error");
            resetStates();
            handleClose();
        } finally {
            setIsLoading(false);
            dynamicGroupDetails();
        }
    };
    const handleCustomerDialogSubmit = async () => {
        // Form validation
        if (!formCategoryName.trim()) {
            props.setSnackInfo("Please enter a category name", "error");
            return;
        }
    
        // Initialize previous headings and rows if undefined
        const previousHeadings = storeUserGroupDetailsForCustomer?.selectedHeadings || [];
        const previousRows = storeUserGroupDetailsForCustomer?.selectedRows || [];
    
        // Combine previous selected headings with the newly selected ones
        let selectedHeadingsCombined = [
            ...previousHeadings, // Previously selected headings
            selectedHeadingForMain.join('/') // Newly selected headings joined by '/'
        ].filter(Boolean); // Filter out any falsy values (e.g., empty strings)
    
        // Remove shorter headings that are included in longer ones
        selectedHeadingsCombined = selectedHeadingsCombined.filter(
            (heading, index, array) =>
                !array.some(
                    (otherHeading) =>
                        otherHeading !== heading &&
                        otherHeading.includes(heading)
                )
        );
    
        // Combine previous selected rows with the newly selected ones
        let selectedRowsCombined = [
            ...previousRows, // Previously selected rows
            selectedRowsForMain.join('/') // Newly selected rows joined by '/'
        ].filter(Boolean); // Filter out any falsy values (e.g., empty strings)
    
        // Remove shorter rows that are included in longer ones
        selectedRowsCombined = selectedRowsCombined.filter(
            (row, index, array) =>
                !array.some(
                    (otherRow) =>
                        otherRow !== row &&
                        otherRow.includes(row)
                )
        );
    
        // Merge rows based on year, ensuring no duplicate years are included
        selectedRowsCombined = selectedRowsCombined.map(row => {
            // Split the row into individual dates
            const dates = row.split('/');
        
            // Process each date to ensure consistent format
            const processedDates = dates.map(date => {
                if (date.trim()) { // Only process non-empty dates
                    // Extract the year and month from the date string
                    const match = date.match(/([a-zA-Z]+)?(\d{4})?/);
                    const monthPart = match && match[1] ? match[1].trim() : null;
                    const yearPart = match && match[2] ? match[2].trim() : null;
        
                    // Return the concatenated month and year if both exist
                    if (monthPart && yearPart) {
                        return monthPart + yearPart;
                    } else if (monthPart) {
                        // If only the month exists
                        return monthPart;
                    } else if (yearPart) {
                        // If only the year exists
                        return yearPart;
                    }
                }
                return null; // Return null for invalid or empty entries
            }).filter(Boolean); // Remove any null or undefined values
        
            // Join the processed dates back together
            return processedDates.join('/');
        });
    
        // Create the payload
        const selectedData = {
            groups: [
                {
                    groupName: formCategoryName,
                    selectedHeadings: selectedHeadingsCombined, // Filtered headings
                    selectedRows: selectedRowsCombined, // Filtered rows
                    formCategoryName: "Sales Customer"
                },
            ],
        };
    
        try {
            setIsLoading(true);
            const response = await HttpService.dynamicGroupingUserWise(selectedData);
            props.setSnackInfo(response.data.message, "success");
            setAdjustModel(false);
            resetStates();
            handleClose();
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.error || "Group Limit Exhausted";
            props.setSnackInfo(errorMessage, "error");
            resetStates();
            handleClose();
        } finally {
            setIsLoading(false);
            dynamicGroupDetails();
        }
    };
    
    const dynamicGroupDetails = async () => {
        try {
            let res = await HttpService.dynamicGroupDetails();

            // Transform the response to get an array of objects with name, groupId, and mainId
            const transformedGroups = res.data.grouping.flatMap(grouping =>
                grouping.groups.map(group => ({
                    name: group.groupName,      // Use 'name' for groupName
                    _id: group._id,             // Use '_id' as is for the group ID
                    mainId: grouping._id,       // Include the main document ID from the grouping
                    formCategoryName: group.formCategoryName,
                    selectedHeadings: group?.selectedHeadings,
                    selectedRows: group?.selectedRows
                }))
            );

            // Filter groups based on FormCategoryName being 'Sales Group'
            const filteredGroups = transformedGroups.filter(group =>
                group.formCategoryName && group.formCategoryName.toLowerCase() === 'sales group' // Fixing the condition
            );

            const filteredGroupsForCustomer = transformedGroups.filter(group =>
                group.formCategoryName && group.formCategoryName.toLowerCase() === 'sales customer' // Fixing the condition
            );

            // Set the filtered data to state
            setStoreGroupDetails(filteredGroups);
            setStoreGroupDetailsCustomer(filteredGroupsForCustomer)

        } catch (error) {
            props.setSnackInfo(error, "Something went wrong");
        }
    };



    const handleDelete = async (groupId, mainId) => {
        try {
            await HttpService.dynamicDeleteGroup(groupId, mainId); // Call the delete API
            // Remove the group from the frontend state
            setStoreGroupDetails((prevDetails) => prevDetails.filter(item => item._id !== groupId));
            setStoreGroupDetailsCustomer((prevDetails) => prevDetails.filter(item => item._id !== groupId));
            dynamicGroupDetails()
        } catch (error) {
            console.error('Error deleting group:', error);
        }
    };

    const handleGroupChange = (event, value) => {
        if (value) {
            // Clear the necessary states
            setMainTable(true)
            setSelectedHeadingForMain([]);
            setSelectedRowsForMain([]);
            setSelectedHeadingForCustomer([]);
            setSelectedRowsForCustomer([]);
            setFormCategoryName('');
            setIsDialogOpen(false);
            setSelectedGroup(value?.mainId)
            setUserGroupDetails(value);
            setSelectedExperienceCenter([]);
            setPivotDatefilters({ startDate: "", endDate: "" });
            setSelectedValue("");
            setSelectedUsers([]);
            setSelectedSearchType("");
            setSearchInput("");
        }
    };

    const handleGroupChangeForCustomer = (event, value) => {

        if (value) {
            // Clear the necessary states
            setShowCustomerTable(true)
            setSelectedHeadingForMain([]);
            setSelectedRowsForMain([]);
            setSelectedHeadingForCustomer([]);
            setSelectedRowsForCustomer([]);
            setFormCategoryName('');

            setSelectedGroupForCustomer(value?.mainId)
            setUserGroupDetailsForCustomer(value);
            setSelectedExperienceCenter([]);
            setPivotDatefilters({ startDate: "", endDate: "" });
            setSelectedValue("");
            setSelectedUsers([]);
            setSelectedSearchType("");
            setSearchInput("");
        }
    }

    const [newTableData, setNewTableData] = React.useState([]);
    // UseEffect hook to call the function when the selectedGroup state changes
    useEffect(() => {
        if (selectedGroup) {
            // Call the function when the selectedGroup changes
            callFunctionForGroup(null, null, null, null, selectedSearchType, searchInput, selectedGroup);
        }
    }, [selectedGroup,showMainTable]);
    // Dependency on selectedGroup to trigger the effect when it changes

    useEffect(() => {
        if (selectedGroupForCustomer) {
            callFunctionForCustomer(null, null, null, null, selectedSearchType, searchInput, selectedGroup);
        }
    }, [selectedGroupForCustomer,showCustomerMainTable]); // Dependency on selectedGroup to trigger the effect when it changes

    // for overall sales
    const callFunctionForGroup = async (addLocation, addExpCenter, usersData, selectedSearchType, searchInput, groupId) => {
        let locationData = addLocation?.map((el) => el._id);
        let expCenterData = addExpCenter?.map((el) => el._id);
        let users = '';

        if ((usersData?.users && usersData?.users.length !== 0) || (selectedUsers && selectedUsers.length !== 0)) {
            users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id);
        }

        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            tokenPercentage: selectedValue !== "" ? selectedValue : "",
            users: users ? users : "",
            userExpCenter: userDetails.experienceCenterId,
            userLocation: userDetails.selectedLocation,
            lost: selectLost !== "" ? selectLost : "",
            pivotValue: 'value',
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : "",
            groupId: selectedGroup
        };

        // Add selectedRole conditionally based on user role
        if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.SalesUser;
        } else {
            obj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL");
        }

        props.setLoading(true);

        try {

            // Pass the object with the group ID
            let response = await HttpService.getSalesDataBasedOnExpCenterForSalesGroup(obj);
            setStoreMainTableData(response.data)
            setNewTableData(response.data)

        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
        }

        props.setLoading(false);
    };


    // for overall customers
    const callFunctionForCustomer = async (addLocation, addExpCenter, usersData, selectedSearchType, searchInput, groupId) => {

        let locationData = addLocation?.map((el) => el._id);
        let expCenterData = addExpCenter?.map((el) => el._id);
        let users = '';

        if ((usersData?.users && usersData?.users.length !== 0) || (selectedUsers && selectedUsers.length !== 0)) {
            users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id);
        }

        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            tokenPercentage: selectedValue !== "" ? selectedValue : "",
            users: users ? users : "",
            userExpCenter: userDetails.experienceCenterId,
            userLocation: userDetails.selectedLocation,
            lost: selectLost !== "" ? selectLost : "",
            pivotValue: 'value',
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : "",
            groupId: selectedGroupForCustomer
        };

        // Add selectedRole conditionally based on user role
        if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.SalesUser;
        } else {
            obj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL");
        }

        props.setLoading(true);

        try {

            // Pass the object with the group ID
            let response = await HttpService.getSalesDataBasedOnExpCenterForSalesGroupForCustomer(obj);
            setStoreMainTableDataForCustomer(response.data)
            // setStoreMainTableData(response.data)
            // setNewTableData(response.data)

        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
        }

        props.setLoading(false);
    };


    const uniqueexperienceCenterCodeForGroup = Array.from(new Set(storeMainTableData.map((el) => el.expCenterCode)));
    const uniqueexperienceCenterCodeForGroupForCustomer = Array.from(new Set(storeMainTableDataForCustomer.map((el) => el.expCenterCode)));

    let uniqueexperienceCenterNamesForGroup = Array.from(new Set(storeMainTableData.map((el) => el.experienceCenterName)));
 
    const formatMonthYear = (monthName, year) => {
        if (!monthName) return ''; // Ensure `monthName` is not null or undefined
    
        const monthAbbr = (month) => month.slice(0, 3); // Get the first 3 letters of the month
        const yearSuffix = (year) => year.toString().slice(-2); // Get the last two digits of the year
    
        if (monthName.includes('/')) {
            // Handle cases with `/` (multiple months)
            const months = monthName.split('/');
            let formattedString = '';
            let previousYear = null;
    
            months.forEach((month, index) => {
                const monthMatch = month.match(/[A-Za-z]+/); // Extract month name
                const yearMatch = month.match(/\d+/); // Extract year
    
                if (!monthMatch || !yearMatch) return; // Skip invalid data
    
                const monthName = monthMatch[0];
                const year = yearMatch[0];
                const monthAbbreviation = monthAbbr(monthName);
                const yearShort = yearSuffix(year);
    
                if (formattedString === '') {
                    formattedString = `${monthAbbreviation}`;
                } else {
                    if (previousYear && year !== previousYear) {
                        formattedString += `-${previousYear.slice(-2)} - ${monthAbbreviation}`;
                    } else {
                        formattedString += `/${monthAbbreviation}`;
                    }
                }
    
                previousYear = year;
            });
    
            // Append the final year suffix
            if (previousYear) {
                formattedString += `-${previousYear.slice(-2)}`;
            }
    
            return formattedString;
        } else {
            // Handle single month without `/`
            const monthAbbreviation = monthAbbr(monthName);
            const yearShort = yearSuffix(year);
            return `${monthAbbreviation}-${yearShort}`;
        }
    };
    
    
    
    

    
    return (
        <div className="App">

            <br />
            <div>
                <Paper className={classes.paper}>
                    <Grid
                        container
                        spacing={2}
                        justifyContent={
                            userDetails?.roles && userDetails.roles.some(role =>
                                [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser, ROLENAME.DGM_Sales].includes(role.name)
                            )
                                ? "flex-start"
                                : "center"
                        }
                        alignItems="center"
                    >
                        {userDetails?.roles &&
                            userDetails.roles.some(role =>
                                [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser, ROLENAME.DGM_Sales,ROLENAME.FinanceUser,ROLENAME.FinanceManager,ROLENAME.FinanceExecutive].includes(role.name)
                            ) && (
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedLocation}
                                            onChange={handleMultipleLocationData}
                                            options={commonLocation}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Location"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            )}
                        {userDetails?.roles &&
                            userDetails.roles.some(role =>
                                [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser, ROLENAME.DGM_Sales,ROLENAME.FinanceUser,ROLENAME.FinanceManager,ROLENAME.FinanceExecutive].includes(role.name)
                            ) && (
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.4rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedExperienceCenter}
                                            onChange={handleMultipleExpData}
                                            options={commonExpCenter}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Exp-Center"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            )}
                        <Grid item xs={12} sm={2}>
                            <TextField
                                id="startDate"
                                name="startDate"
                                label="From Date"
                                type="date"
                                variant="outlined"
                                value={storeDateFilter.startDate}
                                onChange={storePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                id="endDate"
                                name="endDate"
                                label="End Date"
                                type="date"
                                variant="outlined"
                                value={storeDateFilter.endDate}
                                onChange={storePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handlePivotDateFilter}
                                style={{
                                    backgroundColor: "#F50057",
                                    color: "#fff",
                                    padding: "0.4rem 2rem 2rem 2rem",
                                }}
                                className={classes.submitButton}
                            >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={12} sm={2}>
                            <FormControl style={{ width: '70%', marginTop: "0.4rem" }}>
                                <TextField
                                    select
                                    labelId="project-doc"
                                    label="5 % Payment"
                                    variant="outlined"
                                    value={selectedValue}
                                    onChange={(e) => handleSelectChange(e)}
                                >
                                    <MenuItem value="2">All</MenuItem>
                                    <MenuItem value="1">YES</MenuItem>
                                    <MenuItem value="0">NO</MenuItem>
                                </TextField>
                            </FormControl>
                        </Grid>

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.DGM_Sales, ROLENAME.AGMSales].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        >
                                            <MenuItem value={"ALL"}>ALL</MenuItem>
                                            <MenuItem value={ROLENAME.DGM_Sales}>DGM</MenuItem>
                                            <MenuItem value={ROLENAME.AGMSales}>AGM</MenuItem>
                                            <MenuItem value={ROLENAME.SalesManager}>Manager</MenuItem>
                                            <MenuItem value={ROLENAME.AssistantSalesManager}>Assistant Sales Manager</MenuItem>
                                            <MenuItem value={ROLENAME.SalesUser}>Executive</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedUsers}
                                            onChange={(e, v) => handleMultipleUsers(e, v)}
                                            options={usersData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.SalesManager].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={2}>
                                    <FormControl style={{ width: '80%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        >
                                            <MenuItem value={ROLENAME.SalesManager}>Manager</MenuItem>
                                            <MenuItem value={ROLENAME.AssistantSalesManager}>Assistant Sales Manager</MenuItem>
                                            <MenuItem value={ROLENAME.SalesUser}>Executive</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedUsers}
                                            onChange={(e, v) => handleMultipleUsers(e, v)}
                                            options={usersData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.AssistantSalesManager].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={4}>
                                    <FormControl style={{ width: '100%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        >
                                            <MenuItem value={ROLENAME.AssistantSalesManager}>Assistant Sales Manager</MenuItem>
                                            <MenuItem value={ROLENAME.SalesUser}>Executive</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            size="medium"
                                            value={selectedUsers}
                                            onChange={(e, v) => handleMultipleUsers(e, v)}
                                            ListboxProps={{ style: { maxHeight: "15rem" }, position: "bottom-start" }}
                                            options={usersData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.DGM_Sales,ROLENAME.FinanceUser,ROLENAME.FinanceManager,ROLENAME.FinanceExecutive].includes(role.name))) && (
                            <Grid item xs={12} sm={3}>
                                <FormControl style={{ width: '100%', marginTop: "0.4rem" }}>
                                    <TextField
                                        select
                                        labelId="lost-doc"
                                        label="Lost"
                                        variant="outlined"
                                        value={selectLost}
                                        onChange={(e) => handleSelctLost(e)}
                                    >
                                        <MenuItem value="2">All</MenuItem>
                                        <MenuItem value="1">Yes</MenuItem>
                                        <MenuItem value="0">No</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>
                        )}
                    </Grid>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '30px' }}>
                        {/* Search Type Dropdown */}
                        <TextField
                            select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedSearchType}
                            label="Search Type"
                            name="searchType"
                            onChange={(e) => handleSearchType(e.target.value)}
                            variant="outlined"
                            style={{ width: '30%', marginRight: '2%' }}
                            size="small"
                        >
                            {searchTypes && searchTypes?.map((el, index) => (
                                <MenuItem key={index} value={el}>{el}</MenuItem>
                            ))}
                        </TextField>

                        {/* Search Input */}
                        <TextField
                            label="Enter the input"
                            name="searched"
                            size="small"
                            value={searchInput}
                            onChange={(e) => { setSearchInput(e.target.value) }}
                            onKeyDown={handleKeyDown}  // Listening for the "Enter" key press
                            variant="outlined"
                            style={{ width: '80%' }}
                        />

                        {/* Search Button */}
                        <Button
                            disabled={!selectedSearchType || !searchInput}
                            variant="contained"
                            color="primary"
                            size="medium"
                            style={{ alignSelf: "center", marginLeft: 20 }}
                            className={(selectedSearchType && searchInput) ? classes.searchButton : undefined}
                            onClick={() => handleSearch(searchInput.toUpperCase())}
                        >
                            Search
                        </Button>

                        {/* Clear Filter Button */}
                        <Button
                            variant="contained"
                            color="secondary"
                            size="medium"
                            style={{ marginLeft: 10,marginTop:"4px" }}
                            // className={classes.clearButton}
                            onClick={clearDateFilter}
                        >
                            Clear Filter
                        </Button>
                    </div>
                </Paper>
            </div>
            <br />
            <div>
                <>
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={2} >
                            <Button
                                style={{
                                    marginBottom: '10px',
                                    backgroundColor: '#1C375D',
                                    color: '#FFF2EB',}}
                            >
                                Sales Summary-Values
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid container item xs={12} sm={12} style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        {/* Dropdown for selecting a group */}
                        <Grid item xs={12} sm={3}>
                            <FormControl style={{ width: '100%' }}>
                                <Autocomplete
                                    options={storeGroupDetails}
                                    value={storeUserGroupDetails}
                                    getOptionLabel={(option) => option?.name || ''}
                                    onChange={handleGroupChange}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <span style={{ flexGrow: 1 }}>{option?.name || ''}</span>
                                            <IconButton
                                                edge="end"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDelete(option);
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </React.Fragment>
                                    )}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select a Group" variant="outlined" />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                    { isGroupCreationMode && (
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{
                                    backgroundColor: "#3F51B5",
                                    color: "#fff",
                                    padding: "0.4rem 2rem 2rem 2rem",
                                }}
                                onClick={toggleGroupCreationForCancel}
                            >
                                Cancel Group
                            </Button>
                        </Grid>
                    )}

                        {/* Button for creating a group */}
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{
                                    backgroundColor: "#F47E46",
                                    color: "#FFF2EB",
                                    padding: "0.4rem 2rem 2rem 2rem",
                                }}
                                onClick={toggleGroupCreation}
                            >
                                {isGroupCreationMode ? 'Save Group' : 'Create Group'}
                            </Button>
                        </Grid>

                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{
                                    backgroundColor: "#F47E46",
                                    color: "#FFF2EB",
                                    padding: "0.4rem 2rem 2rem 2rem",
                                }}
                                onClick={defaultSalesTable}
                            >
                                Default Group
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                onClick={handleRefreshClick}
                                variant="contained"
                                disabled={isDisabled}
                                style={{ 
                                backgroundColor: isDisabled ? "#cccccc" : "#F47E46", 
                                color: "#FFF2EB",
                                padding: "0.4rem 2rem 2rem 2rem",
                                }}
                            >
                                {isDisabled 
                                ? `Wait (${formatTimeLeft()})` 
                                : "Fetch New Data"}
                            </Button>
                            </Grid>
                    </Grid>


                    {!showMainTable ?
                        <div style={{ maxHeight: '500px', overflow: 'auto' }}>
                            <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '30px' }}>
                                <Table style={{ minWidth: '600px' }}> {/* Ensure a minimum width for horizontal scrolling */}
                                    <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                                        <StyledTableRow>
                                            <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}>Sales Month</StyledTableCell>
                                            {store.slice(0, uniqueexperienceCenterCode.length - 1).map((experienceCenterName, index) => (
                                                <StyledTableCell
                                                    className={classes.bordercolors}
                                                    key={index}
                                                    style={{
                                                        fontSize: index === uniqueexperienceCenterNames.length - 1 ? '15px' : '13px',
                                                        fontWeight: index === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                                        textAlign: 'center',
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 1, // Ensure the same zIndex for all cells
                                                    }}
                                                >
                                                    <Tooltip title={`${experienceCenterName.experienceCenterName}-${experienceCenterName.expCtrCityName}`} placement="top">
                                                        <span style={{ cursor: "pointer" }}>
                                                            {isGroupCreationMode && (
                                                                <Checkbox
                                                                    checked={selectedHeadingForMain.includes(experienceCenterName.expCenterCode)}
                                                                    onChange={() =>
                                                                        handleHeadingCheckboxChange(experienceCenterName.expCenterCode)
                                                                    }
                                                                />

                                                            )}
                                                            {experienceCenterName.expCenterCode}
                                                        </span>
                                                    </Tooltip>
                                                </StyledTableCell>
                                            ))}
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center" }}>
                                            Grand Total
                                            </StyledTableCell>


                                        </StyledTableRow>
                                    </TableHead>

                                    <TableHead style={{ position: 'sticky', top: 0, background: 'white' }}>
                                        {store[0]?.monthlyGrandTotal?.map((month, monthIndex) => (
                                            <StyledTableRow key={monthIndex}>
                                                <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, textAlign: "center" }}>
                                                    {isGroupCreationMode && (
                                                   <Checkbox
                                                   checked={selectedRowsForMain.includes(`${month.monthName}${month.year}`)} // Match the concatenated string
                                                   onChange={() => handleRowCheckboxChange(`${month.monthName}${month.year}`)}
                                               />
                                                    )}
                                                    {`${month.monthName.slice(0, 3)}-${month.year % 100} `}
                                                </StyledTableCell>

                                                {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                                                    <>
                                                        {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                                                            <StyledTableCell
                                                                className={classes.bordercolors}
                                                                key={dataIndex}
                                                                style={{
                                                                    textAlign: "center",
                                                                    cursor: "pointer",
                                                                    top: 0,
                                                                    background: "white",
                                                                    fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                                                    color: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? "#355025" : "#1C375D"
                                                                }}
                                                                onClick={(e) => getDataBasedOnClickSales(e, month, innerEl, 'value')}
                                                            >
                                                                {
                                                                    formatNumberToTwoDecimalPlaces(
                                                                        innerEl.monthlyGrandTotal.find(
                                                                            (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                        )?.totalGrandTotal || 0
                                                                    )
                                                                }
                                                            </StyledTableCell>
                                                        ))}
                                                    </>
                                                ))}
                                            </StyledTableRow>
                                        ))}

                                        <StyledTableRow>
                                            <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}>Grand Total</StyledTableCell>
                                            {uniqueexperienceCenterNames.map((experienceCenterName, index) => (
                                                <StyledTableCell className={classes.bordercolors} key={index} style={{ textAlign: "center", cursor: "pointer", color: "#004d40", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "white" }} onClick={(e) => getDataBasedOnClickSales(e, store[0].monthlyGrandTotal, experienceCenterName, 'total')}>
                                                    {
                                                        formatNumberToTwoDecimalPlaces(store.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.grandTotal : 0), 0))
                                                    }
                                                </StyledTableCell>
                                            ))}
                                        </StyledTableRow>
                                    </TableHead>
                                </Table>
                            </TableContainer>
                        </div>

                        :
                        <div style={{ maxHeight: '500px', overflow: 'auto' }}>
                            <TableContainer
                                component={Paper}
                                classes={{ root: classes.customTableContainer }}
                                style={{ marginTop: '30px' }}
                            >
                                <Table style={{ minWidth: '600px' }}>
                                    {/* Table Header */}
                                    <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                                        <StyledTableRow>
                                            <StyledTableCell
                                                style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: 'center' }}
                                            >
                                                Sales Month
                                            </StyledTableCell>
                                            {storeMainTableData
                                                .slice(0, uniqueexperienceCenterCodeForGroup.length - 1)
                                                .map((experienceCenterName, index) => (
                                                    <StyledTableCell
                                                        key={index}
                                                        style={{
                                                            fontSize:
                                                                index === uniqueexperienceCenterNames.length - 1
                                                                    ? '15px'
                                                                    : '13px',
                                                            fontWeight:
                                                                index === uniqueexperienceCenterNames.length - 1
                                                                    ? 'bolder'
                                                                    : 'normal',
                                                            textAlign: 'center',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 1,
                                                        }}
                                                    >
                                                       
                                                            <span style={{ cursor: 'pointer' }}>
                                                                {isGroupCreationMode && (
                                                                    <Checkbox
                                                                        checked={selectedHeadingForMain.includes(
                                                                            experienceCenterName.expCenterCode
                                                                        )}
                                                                        onChange={() =>
                                                                            handleHeadingCheckboxChange(
                                                                                experienceCenterName.expCenterCode
                                                                            )
                                                                        }
                                                                    />
                                                                )}
                                                                {experienceCenterName.expCenterCode}
                                                            </span>
                                                       
                                                    </StyledTableCell>
                                                ))}
                                            <StyledTableCell style={{ textAlign: 'center' }}>
                                                Grand Totals
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>

                                    {/* Table Body */}
                                    <TableHead style={{ position: 'sticky', top: 0, background: 'white' }}>
                                        {storeMainTableData[0]?.monthlyGrandTotal?.map((month, monthIndex) => (
                                            <StyledTableRow key={monthIndex}>
                                                {/* Monthly Data Row Header */}
                                                <StyledTableCell
                                                    style={{ position: 'sticky', left: 0, textAlign: 'center' }}
                                                >
                                                    {isGroupCreationMode && (
                                                          <Checkbox
                                                          checked={selectedRowsForMain.includes(`${month.monthName}${month.year}`)} // Match the concatenated string
                                                          onChange={() => handleRowCheckboxChange(`${month.monthName}${month.year}`)}
                                                      />
                                                    )}
                                                 {formatMonthYear(month?.monthName,month.year)} {/* Use the formatted month-year */}

                                                </StyledTableCell>

                                                {/* Monthly Data Columns */}
                                                {storeMainTableData.map((centerData, expCenterIndex) => (
                                                    <StyledTableCell
                                                        key={expCenterIndex}
                                                        style={{
                                                            textAlign: 'center',
                                                            cursor: 'pointer',
                                                            top: 0,
                                                            background: 'white',
                                                            fontWeight:
                                                                expCenterIndex === storeMainTableData.length - 1
                                                                    ? 'bolder'
                                                                    : 'normal',
                                                            color:
                                                                expCenterIndex === storeMainTableData.length - 1 ?
                                                                    "#355025" : "#1C375D"
                                                        }}
                                                        onClick={(e) =>
                                                            getDataBasedOnClickSalesForGroup(
                                                                e,
                                                                month,
                                                                { experienceCenterId: centerData?.experienceCenterIds }, // Pass the clicked expCenterCode as innerEl
                                                                'value'
                                                            )
                                                        }
                                                    >
                                                        {formatNumberToTwoDecimalPlaces(
                                                            centerData.monthlyGrandTotal?.find(
                                                                (entry) =>
                                                                    entry.monthName === month.monthName &&
                                                                    entry.year === month.year
                                                            )?.totalGrandTotal || 0
                                                        )}
                                                    </StyledTableCell>
                                                ))}

                                            </StyledTableRow>
                                        ))}

                                        {/* Grand Total Row */}
                                        <StyledTableRow>
                                            <StyledTableCell
                                                style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: 'center' }}
                                            >
                                                Grand Total
                                            </StyledTableCell>

                                            {storeMainTableData.map((experienceCenterName, index) => (
                                                <StyledTableCell
                                                    key={index}
                                                    style={{
                                                        textAlign: 'center',
                                                        cursor: 'pointer',
                                                        color: '#004d40',
                                                        zIndex: 1,
                                                        textDecoration: 'underline',
                                                        fontWeight: 'bolder',
                                                        background: 'white',
                                                    }}
                                                    onClick={(e) =>
                                                        getDataBasedOnClickSalesForGroup(
                                                            e,
                                                            storeMainTableData[0].monthlyGrandTotal,
                                                            { experienceCenterId: experienceCenterName?.experienceCenterIds }, // Pas
                                                            'total'
                                                        )
                                                    }
                                                >
                                                    {formatNumberToTwoDecimalPlaces(
                                                        storeMainTableData.reduce(
                                                            (total, el) =>
                                                                total +
                                                                (el.expCenterCode === experienceCenterName.expCenterCode
                                                                    ? el.grandTotal || 0
                                                                    : 0),
                                                            0
                                                        )
                                                    )}
                                                </StyledTableCell>
                                            ))}
                                        </StyledTableRow>
                                    </TableHead>
                                </Table>
                            </TableContainer>
                        </div>
                    }

                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={2}>
                            <Button
                                style={{
                                    backgroundColor: '#1C375D',
                                    color: '#FFF2EB',
                                    marginTop: '20px',

                                }}
                            >
                                Total No of Customers
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} sm={12} style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        {/* Dropdown for selecting a group */}
                        <Grid item xs={12} sm={3}>
                            <FormControl style={{ width: '100%' }}>
                                <Autocomplete
                                    options={storeGroupDetailsCustomer}
                                    value={storeUserGroupDetailsForCustomer}
                                    getOptionLabel={(option) => option?.name || ''}
                                    onChange={handleGroupChangeForCustomer}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <span style={{ flexGrow: 1 }}>{option?.name || ''}</span>
                                            <IconButton
                                                edge="end"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDelete(option);
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </React.Fragment>
                                    )}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select a Group" variant="outlined" />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                         { isGroupCreationModeForCustomer && (
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{
                                    backgroundColor: "#3F51B5",
                                    color: "#fff",
                                    padding: "0.4rem 2rem 2rem 2rem",
                                }}
                                onClick={toggleGroupCreationForCancelForCuatomer}
                            >
                                Cancel Group
                            </Button>
                        </Grid>
                         )}
                        {/* Button for creating a group */}
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{
                                    backgroundColor: "#F47E46",
                                    color: "#FFF2EB",
                                    padding: "0.4rem 2rem 2rem 2rem",
                                }}
                                onClick={toggleGroupCreationForCustomer}
                            >
                                {isGroupCreationModeForCustomer ? 'Save Group' : 'Create Group'}
                            </Button>
                        </Grid>

                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{
                                    backgroundColor: "#F47E46",
                                    color: "#FFF2EB",
                                    padding: "0.4rem 2rem 2rem 2rem",
                                }}
                                onClick={defaultCustomerTable}
                            >
                                Default Group
                            </Button>
                        </Grid>
                    </Grid>

                    {!showCustomerMainTable ?
                        <div style={{ maxHeight: '500px', overflow: 'auto' }}>
                            <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '30px' }}>
                                <Table style={{ minWidth: '600px' }}> {/* Ensure a minimum width for horizontal scrolling */}
                                    <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                                        <StyledTableRow>
                                            <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}>Sales Month</StyledTableCell>
                                            {store.slice(0, uniqueexperienceCenterCode.length - 1).map((experienceCenterName, index) => (
                                                <StyledTableCell className={classes.bordercolors} key={index}
                                                    style={{
                                                        fontSize: index === uniqueexperienceCenterNames.length - 1 ? '15px' : '13px',
                                                        fontWeight: index === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                                        textAlign: 'center',
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 1, // Ensure the same zIndex for all cells
                                                    }}>
                                                    <Tooltip title={`${experienceCenterName.experienceCenterName}-${experienceCenterName.expCtrCityName}`} placement="top">
                                                        <span style={{ cursor: "pointer" }}>
                                                        
                                                            {isGroupCreationModeForCustomer && (
                                                                <Checkbox
                                                                    checked={selectedHeadingForMain.includes(experienceCenterName.expCenterCode)}
                                                                    onChange={() =>
                                                                        handleHeadingCheckboxChange(experienceCenterName.expCenterCode)
                                                                    }
                                                                />

                                                            )}

                                                            {experienceCenterName.expCenterCode}
                                                        </span>
                                                    </Tooltip>
                                                </StyledTableCell>
                                            ))}
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center" }}>
                                                Grand Total
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableHead style={{ position: 'sticky', top: 0, background: 'white' }}>
                                        {store[0]?.monthlyGrandTotal?.map((month, monthIndex) => (
                                            <StyledTableRow key={monthIndex}>
                                                <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, textAlign: "center" }}>
                                                    {isGroupCreationModeForCustomer && (
                                                        <Checkbox
                                                        checked={selectedRowsForMain.includes(`${month.monthName}${month.year}`)} // Match the concatenated string
                                                        onChange={() => handleRowCheckboxChange(`${month.monthName}${month.year}`)}
                                                    />
                                                    )}
                                                    {`${month.monthName.slice(0, 3)}-${month.year % 100} `}
                                                </StyledTableCell>
                                                {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                                                    <>
                                                        {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                                                            <StyledTableCell
                                                                className={classes.bordercolors}
                                                                key={dataIndex}
                                                                style={{
                                                                    textAlign: "center",
                                                                    cursor: "pointer",
                                                                    cursor: "pointer",
                                                                    // color: "blue",
                                                                    textDecoration: "underline",
                                                                    background: "white",
                                                                    fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                                                    color: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? "#355025" : "#1C375D"
                                                                }}
                                                                onClick={(e) => getDataBasedOnClickSales(e, month, innerEl, 'value')}
                                                            >
                                                                {
                                                                    formatNumberToTwoDecimalPlaces(
                                                                        innerEl.monthlyGrandTotal.find(
                                                                            (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                        )?.count || 0
                                                                    )
                                                                }
                                                            </StyledTableCell>
                                                        ))}
                                                    </>
                                                ))}
                                            </StyledTableRow>
                                        ))}

                                        <StyledTableRow>
                                            <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}>Grand Total</StyledTableCell>
                                            {uniqueexperienceCenterNames.map((experienceCenterName, index) => (
                                                <StyledTableCell className={classes.bordercolors} key={index} style={{ textAlign: "center", cursor: "pointer", color: "#004d40", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "white" }} onClick={(e) => getDataBasedOnClickSales(e, store[0].monthlyGrandTotal, experienceCenterName, 'total')}>
                                                    {
                                                        formatNumberToTwoDecimalPlaces(store.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.count : 0), 0))
                                                    }
                                                </StyledTableCell>
                                            ))}
                                        </StyledTableRow>
                                    </TableHead>
                                </Table>
                            </TableContainer>
                        </div>

                        :
                        <div style={{ maxHeight: '500px', overflow: 'auto' }}>
                            <TableContainer
                                component={Paper}
                                classes={{ root: classes.customTableContainer }}
                                style={{ marginTop: '30px' }}
                            >
                                <Table style={{ minWidth: '600px' }}>
                                    {/* Table Header */}
                                    <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                                        <StyledTableRow>
                                            <StyledTableCell
                                                style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: 'center' }}
                                            >
                                                Sales Month
                                            </StyledTableCell>
                                            {storeMainTableDataForCustomer
                                                .slice(0, uniqueexperienceCenterCodeForGroupForCustomer.length - 1)
                                                .map((experienceCenterName, index) => (
                                                    <StyledTableCell
                                                        key={index}
                                                        style={{
                                                            fontSize:
                                                                index === uniqueexperienceCenterNames.length - 1
                                                                    ? '15px'
                                                                    : '13px',
                                                            fontWeight:
                                                                index === uniqueexperienceCenterNames.length - 1
                                                                    ? 'bolder'
                                                                    : 'normal',
                                                            textAlign: 'center',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 1,
                                                        }}
                                                    >
                                                        <Tooltip
                                                            title={`$
                                                                {experienceCenterName.experienceCenterName}-$
                                                                {experienceCenterName.expCtrCityName}
                                                                `}
                                                            placement="top"
                                                        >
                                                            <span style={{ cursor: 'pointer' }}>
                                                                {isGroupCreationModeForCustomer && (
                                                                    <Checkbox
                                                                        checked={selectedHeadingForMain.includes(
                                                                            experienceCenterName.expCenterCode
                                                                        )}
                                                                        onChange={() =>
                                                                            handleHeadingCheckboxChange(
                                                                                experienceCenterName.expCenterCode
                                                                            )
                                                                        }
                                                                    />
                                                                )}
                                                                {experienceCenterName.expCenterCode}
                                                            </span>
                                                        </Tooltip>
                                                    </StyledTableCell>
                                                ))}
                                            <StyledTableCell style={{ textAlign: 'center' }}>
                                                Grand Totals
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>

                                    {/* Table Body */}
                                    <TableHead style={{ position: 'sticky', top: 0, background: 'white' }}>
                                        {storeMainTableDataForCustomer[0]?.monthlyGrandTotal?.map((month, monthIndex) => (
                                            <StyledTableRow key={monthIndex}>
                                                {/* Monthly Data Row Header */}
                                                <StyledTableCell
                                                    style={{ position: 'sticky', left: 0, textAlign: 'center' }}
                                                >
                                                    {isGroupCreationModeForCustomer && (
                                                         <Checkbox
                                                         checked={selectedRowsForMain.includes(`${month.monthName}${month.year}`)} // Match the concatenated string
                                                         onChange={() => handleRowCheckboxChange(`${month.monthName}${month.year}`)}
                                                     />
                                                    )}
                                                    {formatMonthYear(month?.monthName,month.year)} {/* Use the formatted month-year */}
                                                </StyledTableCell>

                                                {/* Monthly Data Columns */}
                                                {storeMainTableDataForCustomer.map((centerData, expCenterIndex) => (
                                                    <StyledTableCell
                                                        key={expCenterIndex}
                                                        style={{
                                                            textAlign: 'center',
                                                            cursor: 'pointer',
                                                            top: 0,
                                                            background: 'white',
                                                            fontWeight:
                                                                expCenterIndex === storeMainTableDataForCustomer.length - 1
                                                                    ? 'bolder'
                                                                    : 'normal',
                                                            color:
                                                                expCenterIndex === storeMainTableDataForCustomer.length - 1?
                                                                "#355025" : "#1C375D"
                                                        }}
                                                        onClick={(e) =>
                                                            getDataBasedOnClickSalesForGroup(
                                                                e,
                                                                month,
                                                                { experienceCenterId: centerData?.experienceCenterIds }, // Pass the clicked expCenterCode as innerEl
                                                                'value'
                                                            )
                                                        }
                                                    >
                                                        {formatNumberToTwoDecimalPlaces(
                                                            centerData.monthlyGrandTotal?.find(
                                                                (entry) =>
                                                                    entry.monthName === month.monthName &&
                                                                    entry.year === month.year
                                                            )?.count || 0
                                                        )}
                                                    </StyledTableCell>
                                                ))}

                                            </StyledTableRow>
                                        ))}

                                        {/* Grand Total Row */}
                                        <StyledTableRow>
                                            <StyledTableCell
                                                style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: 'center' }}
                                            >
                                                Grand Totals
                                            </StyledTableCell>

                                            {storeMainTableDataForCustomer.map((experienceCenterName, index) => (
                                                <StyledTableCell
                                                    key={index}
                                                    style={{
                                                        textAlign: 'center',
                                                        cursor: 'pointer',
                                                        color: '#004d40',
                                                        zIndex: 1,
                                                        textDecoration: 'underline',
                                                        fontWeight: 'bolder',
                                                        background: 'white',
                                                    }}
                                                    onClick={(e) =>
                                                        getDataBasedOnClickSalesForGroup(
                                                            e,
                                                            storeMainTableDataForCustomer[0].monthlyGrandTotal,
                                                            { experienceCenterId: experienceCenterName?.experienceCenterIds }, // Pas
                                                            'total'
                                                        )
                                                    }
                                                >
                                                    {formatNumberToTwoDecimalPlaces(
                                                        storeMainTableDataForCustomer.reduce(
                                                            (total, el) =>
                                                                total +
                                                                (el.expCenterCode === experienceCenterName.expCenterCode
                                                                    ? el?.count || 0
                                                                    : 0),
                                                            0
                                                        )
                                                    )}
                                                </StyledTableCell>
                                            ))}
                                        </StyledTableRow>
                                    </TableHead>
                                </Table>
                            </TableContainer>
                        </div>
                    }
                    {/* Dialog for formCategoryName */}
                    <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
                        <DialogTitle>Enter Group Name</DialogTitle>
                        <DialogContent>
                            <TextField
                                autoFocus
                                margin="dense"
                                label="Enter Group Name"
                                type="text"
                                fullWidth
                                value={formCategoryName}
                                onChange={(e) => setFormCategoryName(e.target.value)}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setIsDialogOpen(false)} color="primary">
                                Cancel
                            </Button>

                            {
                                adjustModel ?
                                    <Button onClick={handleCustomerDialogSubmit} color="primary">
                                        Submit
                                    </Button>

                                    :
                                    <Button onClick={handleDialogSubmit} color="primary">
                                        Submit
                                    </Button>

                            }

                        </DialogActions>
                    </Dialog>

                </>
            </div>
            <Modal
                title={pivot}
                centered
                visible={showDetailedModal}
                onCancel={() => setShowDetailedModal(false)}
                width={1000}
                maskClosable={true}
                footer={null}
            >
                <div className={classes.csv}>
                    <CSVLink
                        headers={headers}
                        filename={`${pivot}.csv`}
                        data={csvData}
                        ref={csvButtonRef}
                    />
                    <Button
                        onClick={() => csvDownloadHandler(popMonthData)}
                        style={{ backgroundColor: "#355025",color:"#FFF2EB" }}
                        variant="contained"
                        color="secondary"
                    >
                        Download CSV
                    </Button>
                </div>
                {popMonthData && (
                    <TableContainer component={Paper} className={classes.table}>
                        <Table
                            style={{ width: 450 }}
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Project No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Client Name</StyledTableCell>
                                    <StyledTableCell>Created At</StyledTableCell>
                                    <StyledTableCell>Source Of Lead</StyledTableCell>
                                    <StyledTableCell>Value (INR)</StyledTableCell>
                                    <StyledTableCell>City</StyledTableCell>
                                    <StyledTableCell>Sales Won Exp. Ctr. Name</StyledTableCell>
                                    <StyledTableCell>Sales Won Date</StyledTableCell>
                                    <StyledTableCell>Design Sign-Off Date</StyledTableCell>
                                    <StyledTableCell>Material Delivery Date</StyledTableCell>
                                    <StyledTableCell>Actual Completion Date</StyledTableCell>
                                    <StyledTableCell>Token % Received</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {popMonthData?.map((data, i) => {
                                    return (
                                        <StyledTableRow key={i}>
                                            <StyledTableCell>{i + 1}</StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {
                                                    data?.erpProjectNo ?
                                                        <Link to={`/project-logs/${data?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#1C375D", textDecoration: 'underline', textAlign: 'center' }}>  {data?.erpProjectNo}</Link> :
                                                        'NA'
                                                }

                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >

                                                {
                                                    data?.lead_no ?
                                                        <Link to={`/project-logs/${data?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#1C375D", textDecoration: 'underline', textAlign: 'center' }}>  {data?.lead_no}</Link> :
                                                        'NA'
                                                }

                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.customerId?.name}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.createdAt
                                                    ? moment(data?.createdAt).format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.sourceOfLead?.name}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {(data?.staticSalesWonBudget ? data?.staticSalesWonBudget : "N/A")}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.salesWonExpCtrId?.locationId?.name}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.salesWonExpCtrId?.name}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.leadWonDate
                                                    ? moment(data?.leadWonDate).format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.customerDesignSignOffDate
                                                    ? moment(data?.customerDesignSignOffDate).format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.materialDispatchedDate
                                                    ? moment(data?.materialDispatchedDate).format(
                                                        "DD-MM-YYYY"
                                                    )
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.executionCompletionDate
                                                    ? moment(data?.executionCompletionDate).format(
                                                        "DD-MM-YYYY"
                                                    )
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.tokenPercent !== null ? data?.tokenPercent : "null" }
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Modal>
        </div >
    );
}

export default connect(null, { setLoading, setSnackInfo })(SalesSummary);
